module.exports = __webpack_public_path__ + "img/CARAC2.bafd193e.jpg";